With this step, you are going to create a new IAM role and associate that role
with the service account using
[Amazon EKS Pod Identity](https://docs.aws.amazon.com/eks/latest/userguide/pod-identities.html).

**Note:** This requires the pganalyze collector version 0.58.0 and above.

If you haven't installed Amazon EKS Pod Identity Agent add-on, install it with
this command:

```bash
aws eks create-addon --cluster-name mycluster \
  --addon-name eks-pod-identity-agent
```

Create an IAM role that will be mapped with the Kubernetes service account. The
following command will create a role named `pganalyzeServiceAccountRole`.


```bash
aws iam create-role --role-name pganalyzeServiceAccountRole \
  --description "For pganalyze collector service account" \
  --assume-role-policy-document '{
  "Version": "2012-10-17",
  "Statement": [
    {
      "Effect": "Allow",
      "Principal": {
          "Service": "pods.eks.amazonaws.com"
      },
      "Action": [
          "sts:AssumeRole",
          "sts:TagSession"
      ]
    }
  ]
}'
```

Attach the policy you created earlier to the created account. The command below
assumes that the policy name is `pganalyze`:

```bash
aws iam attach-role-policy --role-name pganalyzeServiceAccountRole \
  --policy-arn arn:aws:iam::<aws-account-id>:policy/pganalyze
```

Create Pod Identity association using the role just created:

```bash
aws eks create-pod-identity-association \
  --cluster-name mycluster \
  --namespace default \
  --service-account pganalyze-service-account \
  --role-arn arn:aws:iam::<aws-account-id>:role/pganalyzeServiceAccountRole
```
